const NavigationConstants = {
  // Navigation specific
  OPEN_SLIDEOUT: 'SR_NAV_OPEN_SLIDEOUT',
  CHANGE_SLIDEOUT: 'SR_NAV_CHANGE_SLIDEOUT',
  CLOSE_SLIDEOUT: 'SR_NAV_CLOSE_SLIDEOUT',
  CLOSE_ALL_SLIDEOUTS: 'SR_NAV_CLOSE_ALL_SLIDEOUTS',

  SHOW_DIALOG: 'SR_NAV_SHOW_DIALOG',
  HIDE_DIALOG: 'SR_NAV_HIDE_DIALOG',

  // NOT USED, Defined for safety: prevent case matching for 'undefined'.
  RESET: 'NOT_USED_SR_NAV_RESET',
  GET: 'NOT_USED_SR_NAV_GET',
  GET_SUCCESS: 'NOT_USED_SR_NAV_GET_SUCCESS',
  GET_FAIL: 'NOT_USED_SR_NAV_GET_FAIL',
  GET_FOR_OPEN: 'NOT_USED_SR_NAV_FOR_OPEN',
  GET_FOR_OPEN_SUCCESS: 'NOT_USED_SR_NAV_FOR_OPEN_SUCCESS',
  GET_FOR_OPEN_FAIL: 'NOT_USED_SR_NAV_FOR_OPEN_FAIL',
  SAVE: 'NOT_USED_SR_NAV_SAVE',
  SAVE_SUCCESS: 'NOT_USED_SR_NAV_SAVE_SUCCESS',
  SAVE_FAIL: 'NOT_USED_SR_NAV_SAVE_FAIL',
  REMOVE: 'NOT_USED_SR_NAV_REMOVE',
  REMOVE_SUCCESS: 'NOT_USED_SR_NAV_REMOVE_SUCCESS',
  REMOVE_FAIL: 'NOT_USED_SR_NAV_REMOVE_FAIL',
  CREATE: 'NOT_USED_SR_NAV_CREATE',
  OPEN: 'NOT_USED_SR_NAV_OPEN',
  OPEN_READONLY: 'NOT_USED_SR_NAV_OPEN_READONLY',
  MODIFY: 'NOT_USED_SR_NAV_MODIFY',
  RELOAD: 'NOT_USED_SR_NAV_RELOAD',
  SET_VISIBLE_RANGE: 'NOT_USED_SR_NAV_SET_VISIBLE_RANGE',
  SET_FILTER: 'NOT_USED_SR_NAV_SET_FILTER',
  SET_SORTORDER: 'NOT_USED_SR_NAV_SET_SORTORDER',
  SET_SELECTION: 'NOT_USED_SR_NAV_SET_SELECTION',
  MODIFY_SELECTION: 'NOT_USED_SR_NAV_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'NOT_USED_SR_NAV_ALLOW_MULTI_SELECT',
  ENSURE_SELECTION_IS_VISIBLE: 'NOT_USED_SR_NAV_ENSURE_SELECTION_IS_VISIBLE',
  FIND: 'NOT_USED_SR_NAV_FIND',
  FIND_SUCCESS: 'NOT_USED_SR_NAV_FIND_SUCCESS',
  FIND_FAIL: 'NOT_USED_SR_NAV_FIND_FAIL'
};

export default NavigationConstants;
